import Icons from "@/src/components/Icons";
import { useUserStore } from "@/src/store/useUserStore";
import { commentApi } from "@/src/utils/api/comments";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import moment from "jalali-moment";
import { useState } from "react";
import { toast } from "react-toastify";
import emptmom from "../../assets/img/emptMom.png";


interface commentsProps {
  data: any;
  reload: any;
  setReload: any;
}
function ItemComments({ data, reload, setReload }: commentsProps) {
  const [reply, setReply] = useState<any>("");
  let featuresArray = null;
  let commentText = data.comment || "";
  let parts: string[] = ["", ""];

  if (data.comment) {
    if (data.comment.includes("دلایل :")) {
      parts = data.comment.split("دلایل :");
      featuresArray = parts[1]
        .split(",")
        .map((item: string) => item.trim())
        .filter(Boolean);
    } else if (data.comment.includes("دلایل:")) {
      parts = data.comment.split("دلایل:");
      featuresArray = parts[1]
        .split(",")
        .map((item: string) => item.trim())
        .filter(Boolean);
    } else {
      parts[0] = commentText;
    }
  }

  const { user } = useUserStore();
  return (
    <div className="bg-white shadow-mmpz rounded-xl p-2 min-h-[210px] flex flex-col justify-between gap-3">
      <div className="title flex items-center justify-between">
        <span className="text-[#4B4B4B] font-bold  w-1/3 text-sm">
          {data.userName}
        </span>
        <span className="flex items-center gap-3">
          {" "}
          <Icons name="star" />
          {data.star ? digitsEnToFa(data.star) : ""}
        </span>
        <span className="p-1 shadow-mmpz rounded-xl flex items-center gap-2 text-sm text-gray-300-mmpz">
          <Icons name="time" />{" "}
          {digitsEnToFa(moment(data.date).format("ddd jDD-jMM-jYYYY"))}
        </span>
      </div>
      <span className="text-sm text-gray-200-mmpz ">{data.enterpriseName}</span>
      <span className="text-sm text-gray-200-mmpz">{data.foodName}</span>
      <span className="text-sm text-gray-200-mmpz"></span>
      <div className="flex flex-wrap gap-2">
        {featuresArray &&
          featuresArray.length > 0 &&
          featuresArray.map((item: any, index: number) => {
            return (
              <span
                key={index}
                className="item bg-gray-200-mmpz text-white rounded-lg px-2 py-2 text-xs"
              >
                {item}
              </span>
            );
          })}
      </div>
      <p className="text-[#1E1E1E] text-sm">{parts[0]}</p>
      {data.reply ? (
        <div className="gap-4 flex items-center">
          <div className="reply bg-[#E7E7E7] p-2 rounded-xl min-h-[56px] flex flex-col gap-2 w-full">
            <div className="title text-primary-300 text-xs text-left">
              پاسخ {user?.alias}
            </div>
            <p className="text-xs text-[#1E1E1E]">{data.reply}</p>
          </div>
          <img
            src={
              user?.profilePictureUrl
                ?  user.profilePictureUrl
                : emptmom
            }
            alt=""
            className="w-[20px] h-[20px] rounded-xl shadow-mmpz border border-gray-200-mmpz"
          />
        </div>
      ) : (
        <div className="flex items-center gap-4">
          <input
            type="text"
            className="w-full shadow-mmpz placeholder:text-sm  placeholder:text-gray-200-mmpz px-2 py-3 border border-gray-100-mmpz rounded-lg"
            placeholder="پاسخ به نظر"
            onChange={(e) => {
              setReply(e.target.value);
            }}
          />

          <button
            className="text-sm py-3 px-6 bg-primary-300 text-white rounded-xl"
            onClick={() => {
              commentApi
                .reply(data?.orderId, reply)
                .then(() => {
                  toast.success("پاسخ شما با موفقیت ثبت شد.");
                  setReload(reload + 1);
                })
                .catch((err) => {
                  toast.error(err.response.data.message);
                });
            }}
          >
            ثبت
          </button>
        </div>
      )}
    </div>
  );
}

export default ItemComments;
